import React from 'react';
import { MessageSquareIcon, PrinterIcon, ScanLineIcon } from 'lucide-react';
import { formatRwf } from '../../../utils/currency';
const items = [{
  name: 'Brochettes (beef)',
  qty: 2,
  price: 3000
}, {
  name: 'Fresh passion juice',
  qty: 2,
  price: 1500
}, {
  name: 'Chips, large',
  qty: 1,
  price: 2000
}];
export function CheckoutScreen() {
  const total = items.reduce((s, i) => s + i.qty * i.price, 0);
  return <div className="w-full max-w-[380px] rounded-[14px] bg-white p-5 shadow-[0_18px_40px_-24px_rgba(11,11,11,0.28)]" data-id="element-1256" data-mp="3m6qfgrvj5zmd">
      <div className="flex items-center justify-between" data-id="element-1257" data-mp="3h85lvbasae6w">
        <p className="text-[14px] font-semibold text-ink" data-id="element-1258" data-mp="3vy4ih9moxhk9">Table 4 · Order #2217</p>
        <span className="inline-flex items-center gap-1 rounded-full bg-canvas-warm px-2.5 py-1 text-[11px] font-medium text-ink" data-id="element-1259" data-mp="3qyrxkufdqkkb">
          <ScanLineIcon className="h-3 w-3" aria-hidden="true" data-id="element-1260" data-mp="8tx2mtu5izre" />
          Scan
        </span>
      </div>
      <ul className="mt-4 divide-y divide-canvas-line" data-id="element-1261" data-mp="4sbl2v6o9xav">
        {items.map(i => <li key={i.name} className="flex items-center justify-between py-2.5 text-[13px]" data-id="element-1262" data-mp="4xtttdlqshx6">
            <span className="text-ink-soft" data-id="element-1263" data-mp="8xvjspi47mwm">
              <span className="mr-2 font-semibold text-ink" data-id="element-1264" data-mp="8yx4lloxnnrj">{i.qty}×</span>
              {i.name}
            </span>
            <span className="font-medium text-ink" data-id="element-1265" data-mp="e030tthsxt5t">{formatRwf(i.qty * i.price)}</span>
          </li>)}
      </ul>
      <div className="mt-2 flex items-center justify-between border-t border-canvas-line pt-3" data-id="element-1266" data-mp="nw5zgpdg39o0">
        <span className="text-[13px] font-semibold text-ink" data-id="element-1267" data-mp="rx9jlo2izrv1">Total</span>
        <span className="text-[18px] font-semibold tracking-[-0.02em] text-ink" data-id="element-1268" data-mp="rvexw7jfjvpw">{formatRwf(total)}</span>
      </div>
      <p className="mt-4 text-[12px] font-medium text-ink-muted" data-id="element-1269" data-mp="11nb465vo6s57">Send EBM receipt</p>
      <div className="mt-2 grid grid-cols-2 gap-2" data-id="element-1270" data-mp="11p5hay0p9fyq">
        <span className="flex items-center justify-center gap-1.5 rounded-[8px] border border-canvas-line py-2.5 text-[12px] font-medium text-ink" data-id="element-1271" data-mp="16ngpl4bcjieu">
          <PrinterIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1272" data-mp="1bj4d7fa6k3i8" />
          Print
        </span>
        <span className="flex items-center justify-center gap-1.5 rounded-[8px] bg-brand py-2.5 text-[12px] font-semibold text-white" data-id="element-1273" data-mp="lv0cqj0ixz1l">
          <MessageSquareIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1274" data-mp="vneh7jizljrg" />
          SMS to 078 •••• 214
        </span>
      </div>
    </div>;
}